<template>
  <div />
</template>

<script>
import * as AuthenticationService from '../services/AuthenticationService.js';

export default {
  props: ['redirect'],
  async created() {
    await AuthenticationService.LogoutAsync();
    this.$router.push({ name: 'Login', query: { redirect: this.redirect || '' } });
  }
};
</script>
